// Module
var code = "<tpl if=\"action\">\n    <div class=\"appointmentView-element card\">\n        <div class=\"appointmentView-element-row title h2\">{action}</div>\n        <tpl if=\"description\">\n            <div class=\"appointmentView-element-row description medium-editor\">{description:markdown}</div>\n        </tpl>\n    </div>\n</tpl>\n";
// Exports
module.exports = code;